/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Screen from '../Screen';
import Userview from '../../Userview/Userview';
import './User.css';

/**
 * Represents the user maintenance screen.
 */

export default class User extends Screen {

    /**
     * Properties.
     */

    static propTypes = {
        user:                     PropTypes.object,
        onBack:                   PropTypes.func.isRequired
    }

    /**
     * Event that fires when the user closes the user maintenance.
     */    

    _onCloseMaintenance = () => {

        // Closing the popup screen

        this.props.onBack();
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.user.title);

        // Loading the user
        
        this.userview.refresh(this.props.user);

    }

    /** 
     * User maintenance screen renderer.
     */

    render() {
        return (
            <div className="user">

                {/* User view and maintenance */}

                <Userview ref={c => {this.userview = c;}} context={this.props.context} onLoading={this.props.onLoading} onClose={this._onCloseMaintenance} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/User/User.js